<template>
  <div id="maintenance">
    <div class="container">
      <!-- Container -->
      <div class="section-title text-center center zeropadding">
        <h2>{{ $t("index.maintenance") }}</h2>
        <div class="line">
          <hr />
        </div>
        <div class="clearfix"></div>
        <small
          ><em>{{ $t("index.maintenancein") }}</em></small
        >
      </div>
      <div class="space"></div>

      <a-skeleton active :loading="loading1">
        <div class="card">
          <div class="card-head">
            <div style="min-width: 150px">{{ $t("index.maintenance1") }}</div>
            <div class="noMore" :title="$t('index.maintenance1info')">
              {{ $t("index.maintenance1info") }}
            </div>
          </div>
          <div class="card-content">
            <a-select
              ref="select"
              v-model:value="firDevice"
              style="width: 250px"
              :options="options"
              @change="handleChange1"
            ></a-select>

            <a-table
              style="margin-top: 10px"
              :columns="columns1"
              :dataSource="dataSource1"
              bordered
              :tool-config="toolConfig"
              :loading="tbLoading1"
              :pagination="pagination"
              :row-key="(record) => record.Id"
              :row-selection="selection.rowSelection"
              @change="handleTableChange1"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.dataIndex === 'IsEnabled'">
                  <a-tag v-if="record.IsEnabled == 0" color="orange">
                    {{ $t("main.disabled") }}
                  </a-tag>
                  <a-tag v-if="record.IsEnabled == 1" color="blue">
                    {{ $t("main.enabled") }}
                  </a-tag>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </a-skeleton>

      <a-skeleton active :loading="loading2">
        <div class="card">
          <div class="card-head">
            <div>{{ $t("index.maintenance2") }}</div>
          </div>
          <div class="card-content">
            <!--             <a-select
              ref="select"
              v-model:value="firDevice"
              style="width: 250px"
              :options="options"
              @change="handleChange2"
            ></a-select> -->

            <a-table
              :columns="columns2"
              :dataSource="dataSource2"
              bordered
              :row-key="(record) => record.Id"
              :show-pagination="true"
              :tool-config="toolConfig"
              :loading="tbLoading2"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.dataIndex === 'IsNormal'">
                  <a-tag v-if="record.IsNormal == 0" color="orange">
                    {{ $t("main.overdue") }}
                  </a-tag>
                  <a-tag v-if="record.IsNormal == 1" color="blue">
                    {{ $t("main.normal") }}
                  </a-tag>
                </template>
                <template v-if="column.dataIndex === 'action'">
                  <a-space>
                    <a-button type="primary" @click="openForm(record)">{{
                      $t("main.maintain")
                    }}</a-button>
                  </a-space>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </a-skeleton>

      <a-drawer
        v-model:open="Fopen"
        :title="$t('index.maintenance2')"
        :width="1000"
        :destroy-on-close="true"
        @close="onFormClose"
      >
        <a-card
          :bordered="false"
          :loading="infoLoading"
          :title="$t('main.title1')"
          style="margin-bottom: 20px"
        >
          <a-descriptions bordered :column="2">
            <a-descriptions-item :label="$t('main.project')">{{
              maintenance.Project
            }}</a-descriptions-item>
            <a-descriptions-item :label="$t('main.orderNumber')">{{
              maintenance.OrderNumber
            }}</a-descriptions-item>

            <a-descriptions-item :label="$t('main.label')">{{
              maintenance.Lable
            }}</a-descriptions-item>
            <a-descriptions-item :label="$t('main.realName')">{{
              maintenance.RealName
            }}</a-descriptions-item>

            <a-descriptions-item :label="$t('main.content')">{{
              maintenance.Content
            }}</a-descriptions-item>
            <a-descriptions-item :label="$t('main.createTime')">{{
              maintenance.CreateTime
            }}</a-descriptions-item>

            <a-descriptions-item :label="$t('main.cycle')">{{
              maintenance.CycleHours
            }}</a-descriptions-item>
            <a-descriptions-item :label="$t('main.surplus')">{{
              maintenance.SurplusHour
            }}</a-descriptions-item>

            <a-descriptions-item :label="$t('main.warningHours')">{{
              maintenance.WarningHours
            }}</a-descriptions-item>
            <a-descriptions-item :label="$t('main.warningTime')">{{
              maintenance.WarningTime
            }}</a-descriptions-item>

            <a-descriptions-item :label="$t('main.isEnabled')">{{
              maintenance.Enabled
            }}</a-descriptions-item>
            <a-descriptions-item :label="$t('main.isNormal')">{{
              maintenance.Normal
            }}</a-descriptions-item>
          </a-descriptions>

          <div class="footer">
            <a-button
              :loading="confirmLoad"
              class="confirmBtn"
              type="primary"
              @click="confirm()"
              >{{ $t("main.confirm") }}</a-button
            >

            <a-date-picker
              v-model:value="selectTime"
              class="confirmBtn"
              show-time
              placeholder="Select Time"
              :disabled-date="disabledDate"
              :disabled-time="disabledDateTime"
              :allow-clear="false"
              @ok="onOk"
            />
          </div>
        </a-card>

        <a-card :bordered="false" :loading="hisLoading" :title="$t('main.title2')">
          <a-table
            style="margin-top: 10px"
            :columns="formColumns"
            :dataSource="formDataSource"
            bordered
            :row-key="(record) => record.Id"
            :tool-config="toolConfig"
            :pagination="pagination2"
            @change="handleTableChange2"
          >
          </a-table>
        </a-card>
      </a-drawer>
    </div>
  </div>
</template>

<script setup>
/**
 * CreationTime：2024.5.22 Wen
 * LastEditingTime：2024.5.31 Fri
 * Written by ShiYechen
 */
import { ref, computed, watch } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import { message } from "ant-design-vue";
import { useI18n } from "vue-i18n";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";

const { t } = useI18n();

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

/**用户信息 */
const user = ref(JSON.parse(localStorage.getItem("user")));

/**保养项目部分 */
const loading1 = ref(false);
/**保养项目选中设备 */
const firDevice = ref();
const deviceSeries = ref("");
/**下拉选择框设备列表 */
const options = ref([]);
/**保养项目表格 */
const dataSource1 = ref([]);
/**表格加载状态 */
const tbLoading1 = ref(false);
const toolConfig = { refresh: true, height: true, columnSetting: false, striped: false };
/**表头数据 */
const columns1 = [
  {
    title: t("main.project"),
    dataIndex: "Project",
  },
  {
    title: t("main.label"),
    dataIndex: "Lable",
  },
  {
    title: t("main.content"),
    dataIndex: "Content",
  },
  {
    title: t("main.cycle"),
    dataIndex: "CycleHours",
  },
  {
    title: t("main.warningHours"),
    dataIndex: "WarningHours",
  },
  {
    title: t("main.isEnabled"),
    dataIndex: "IsEnabled",
  },
];
/**分页 */
const pagination = ref({
  total: 0,
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
});
/**Form表格分页 */
const pagination2 = ref({
  total: 0,
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
});

/**维护保养部分 */
const loading2 = ref(false);
/**维护保养选中设备 */
const secDevice = ref();
/**维护保养表格 */
const dataSource2 = ref([]);
/**表格加载状态 */
const tbLoading2 = ref(false);
/**表头数据 */
const columns2 = [
  {
    title: t("main.project"),
    dataIndex: "Project",
  },
  {
    title: t("main.label"),
    dataIndex: "Lable",
  },
  {
    title: t("main.content"),
    dataIndex: "Content",
  },
  {
    title: t("main.cycle"),
    dataIndex: "CycleHours",
  },
  {
    title: t("main.surplus"),
    dataIndex: "SurplusHour",
  },
  {
    title: t("main.isNormal"),
    dataIndex: "IsNormal",
  },
  {
    title: t("main.action"),
    dataIndex: "action",
    align: "center",
  },
];
/**表格选中Id存放数组 */
const selectedRowKeys = ref([]);
/**表格选择配置 */
const selection = {
  rowSelection: {
    hideDefaultSelections: true,
    hideSelectAll: true,
    selectedRowKeys: selectedRowKeys,
    onChange: (selectedRowKey, selectedRows) => {
      selectedRowKeys.value = selectedRowKey;
    },
    onSelect: (record, selected, selectedRows) => {
      /**如果是选中 */
      if (selected) {
        /**绑定的时候绑的是保养详情Id，也就是查询保养项目绑定列表获取的DetailId(详见getBindList方法的element)，查询保养详情列表时这一项为Id(详见getBindList方法的item)，同时也是表格的Id */
        bindItem(record.Id)
          .then((data) => {
            message.success(data);
            loadData1();
            loadData2();
          })
          .catch((error) => {
            message.error(error.toString());
          });
      } else {
        if (record.uId) {
          /**解绑的时候解绑的时保养绑定Id，也就是查询保养项目绑定列表获取的Id(详见getBindList方法的element)，查询保养详情列表时这一项查询不到，只有将查询保养项目绑定列表获取的Id作为uId传递给表格作为uId在此处拿到 */
          unBindItem(record.uId)
            .then((data) => {
              message.success(data);
              loadData1();
              loadData2();
            })
            .catch((error) => {
              message.error(error.toString());
            });
        }
      }
    },
  },
};

/**From打开状态 */
const Fopen = ref(false);
/**Form保养详情加载状态 */
const infoLoading = ref(false);
/**Form确认保养按钮加载状态 */
const confirmLoad = ref(false);
/**Form保养详情信息 */
const maintenance = ref({});
/**Form保养历史加载状态 */
const hisLoading = ref(false);
/**Form表格表头数据 */
const formColumns = [
  {
    title: t("main.project"),
    dataIndex: "Project",
  },
  {
    title: t("main.content"),
    dataIndex: "Content",
  },
  {
    title: t("main.name"),
    dataIndex: "RealName",
  },
  {
    title: t("main.time"),
    dataIndex: "MaintenanceTime",
  },
  {
    title: t("main.createTime"),
    dataIndex: "CreateTime",
  },
];
/**Form表格数据 */
const formDataSource = ref([]);
/**From时间选择器 */
const selectTime = ref();

/**
 * 主函数入口
 */
init();

async function init() {
  localStorage.setItem("router", "maintenance");

  await getDevice()
    .then((data) => {
      if (Array.isArray(data)) {
        data.map((item, index) => {
          options.value[index] = {
            value: item.equipmentid,
            label: item.ordernumber,
            series: item.seriesname,
          };
        });
        firDevice.value = options.value[0].value;
        deviceSeries.value = data[0].seriesname;

        loadData1();
        loadData2();
      }
    })
    .catch((error) => {
      message.error(error.toString());
    });
}

/**获取设备 */
function getDevice() {
  loading1.value = true;
  loading2.value = true;
  return new Promise((resolve, reject) => {
    axios
      .post("api/Machine/GetMyMachine", {
        UserId: user.value.UserId,
      })
      .then(function (response) {
        loading1.value = false;
        loading2.value = false;
        if (response.data.code != 200) {
          reject(response.data.info);
        } else {
          resolve(response.data.ReturnData);
        }
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

/**获取保养项目列表 */
function getList() {
  return new Promise((resolve, reject) => {
    axios
      .post("api/Maintenance/MDetailsList", {
        Id: "", //保养详情Id
        Project: "", //保养项目
        Lable: deviceSeries.value, //保养标签（英文,分隔）
        PrevPageNums: (pagination.value.current - 1) * pagination.value.pageSize,
        TopNums: pagination.value.pageSize,
      })
      .then(function (response) {
        if (response.data.code != 200) {
          reject(response.data.info);
        } else {
          pagination.value.total = response.data.ReturnCount;
          resolve(response.data.ReturnData);
        }
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

/**获取保养项目绑定列表 */
function getBindList(MachineId, Id) {
  return new Promise((resolve, reject) => {
    axios
      .post("api/Maintenance/MMachineList", {
        Id: Id ? Id : "",
        UserId: user.value.UserId,
        MachineId: MachineId ? MachineId : firDevice.value,
      })
      .then(function (response) {
        if (response.data.code != 200) {
          reject(response.data.info);
        } else {
          resolve(response.data.ReturnData);
        }
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

/**绑定保养项目 */
function bindItem(DetailId) {
  return new Promise((resolve, reject) => {
    axios
      .post("api/Maintenance/SaveMMachine", {
        Id: "",
        UserId: user.value.UserId,
        MachineId: firDevice.value,
        DetailId: DetailId, //保养详情Id
      })
      .then(function (response) {
        if (response.data.code != 200) {
          reject(response.data.info);
        } else {
          resolve(response.data.ReturnData);
        }
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

/**解绑保养项目 */
function unBindItem(DetailId) {
  return new Promise((resolve, reject) => {
    axios
      .post("api/Maintenance/DeleteMMachine", {
        Id: DetailId,
      })
      .then(function (response) {
        if (response.data.code != 200) {
          reject(response.data.info);
        } else {
          resolve(response.data.ReturnData);
        }
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

/**获取保养历史记录 */
function getHistory(DetailId) {
  return new Promise((resolve, reject) => {
    axios
      .post("api/Maintenance/GetMRecords", {
        MmId: DetailId,
        PrevPageNums: (pagination2.value.current - 1) * pagination2.value.pageSize,
        TopNums: pagination2.value.pageSize,
      })
      .then(function (response) {
        if (response.data.code != 200) {
          reject(response.data.info);
        } else {
          pagination2.value.total = response.data.ReturnCount;
          resolve(response.data.ReturnData);
        }
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

/**获取保养项目表格 */
async function loadData1(MachineId) {
  tbLoading1.value = true;
  selectedRowKeys.value = [];

  /**先获取保养项目列表 */
  await getList()
    .then((data) => {
      if (Array.isArray(data)) {
        dataSource1.value = data;
      }
    })
    .catch((error) => {
      message.error(error.toString());
    });

  /**再获取该设备保养项目绑定列表，给绑定了保养项目表格行前面打钩 */
  await getBindList(MachineId)
    .then((data) => {
      tbLoading1.value = false;
      if (Array.isArray(data)) {
        let arr = [];
        data.forEach((element) => {
          dataSource1.value.forEach((item) => {
            if (element.DetailId == item.Id) {
              /**arr是后面的已经绑定上保养项目表格回显使用 */
              arr.push(item.Id);
              /**uId作为已绑定项目的绑定Id传递至表格，后面删除的时候可以用到 */
              item.uId = element.Id;
            }
          });
        });
        selectedRowKeys.value = newArrFn(arr);
      }
    })
    .catch((error) => {
      message.error(error.toString());
    });
}

/**获取维护保养表格 */
async function loadData2() {
  tbLoading2.value = true;

  await getBindList()
    .then((data) => {
      tbLoading2.value = false;
      if (Array.isArray(data)) {
        dataSource2.value = data;
      }
    })
    .catch((error) => {
      message.error(error.toString());
    });
}

/**保养项目切换设备 */
function handleChange1(value, option) {
  deviceSeries.value = option.series;
  loadData1(firDevice.value);
  loadData2();
}

/**维护保养切换设备 */
function handleChange2() {
  loadData2();
}

/**点击保养按钮，打开保养表单 */
async function openForm(record) {
  Fopen.value = true;
  maintenance.value = JSON.parse(JSON.stringify(record));
  selectTime.value = dayjs();

  /**打开表单的时候要重新查询一下信息，避免过期状态不同步 */
  infoLoading.value = true;
  await getBindList(record.MachineId, record.Id)
    .then((data) => {
      infoLoading.value = false;
      if (Array.isArray(data)) {
        maintenance.value = JSON.parse(JSON.stringify(data[0]));
      }
    })
    .catch((error) => {
      message.error(error.toString());
    });

  maintenance.value.Enabled =
    maintenance.value.IsEnabled == 1 ? t("main.yes") : t("main.no");
  maintenance.value.Normal =
    maintenance.value.IsNormal == 1 ? t("main.normal") : t("main.overdue");

  /**获取一下保养历史记录 */
  hisLoading.value = true;
  await getHistory(record.Id)
    .then((data) => {
      hisLoading.value = false;
      if (Array.isArray(data)) {
        formDataSource.value = data;
        formDataSource.value.forEach((element) => {
          element.Project = maintenance.value.Project;
          element.Content = maintenance.value.Content;
        });
      }
    })
    .catch((error) => {
      message.error(error.toString());
    });
}

/**点击确认保养打开Form */
async function confirm() {
  if (selectTime.value) {
    confirmLoad.value = true;
    await saveRecord()
      .then((data) => {
        confirmLoad.value = false;
        message.success(data);
        /**重新获取一下状态 */
        openForm(maintenance.value);
        loadData2();
      })
      .catch((error) => {
        message.error(error.toString());
      });
  } else {
    message.error(t("main.pleaseSelect") + "!");
  }
}

/**保存保养项目记录 */
function saveRecord() {
  const formattedDate = utcToCST(new Date(selectTime.value.toISOString()));

  return new Promise((resolve, reject) => {
    axios
      .post("api/Maintenance/InsertMRecords", {
        Id: "",
        MmId: maintenance.value.Id, //保养项目绑定Id
        MaintenanceTime: formattedDate, //保养日期
        MaintenanceUser: user.value.UserId, //保养人员Id
        State: maintenance.value.IsNormal, //保养状态（0：过期 1：正常）
      })
      .then(function (response) {
        if (response.data.code != 200) {
          reject(response.data.info);
        } else {
          resolve(response.data.ReturnData);
        }
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

/**关闭保养表单 */
function onFormClose() {
  maintenance.value = {};
  Fopen.value = false;
}

/**分页方法1 */
function handleTableChange1(e) {
  pagination.value = e;
  loadData1();
}

/**分页方法2 */
async function handleTableChange2(e) {
  pagination2.value = e;

  hisLoading.value = true;
  await getHistory(maintenance.value.Id)
    .then((data) => {
      hisLoading.value = false;
      if (Array.isArray(data)) {
        formDataSource.value = data;
        formDataSource.value.forEach((element) => {
          element.Project = maintenance.value.Project;
          element.Content = maintenance.value.Content;
        });
      }
    })
    .catch((error) => {
      message.error(error.toString());
    });
}

/**时间选择器禁用今天之后的日期 */
function disabledDate(current) {
  // Can not select days after today and today
  return current && current > dayjs().endOf("day");
}

/**时间选择器禁用打开选择器之后的时分秒 */
function disabledDateTime(current) {
  return {
    disabledHours: () => range(0, 24).splice(current.$H + 1),
    disabledMinutes: () => range(0, 60).splice(current.$m + 1),
    disabledSeconds: () => range(0, 60).splice(current.$s + 1),
  };
}

/**时间选择器禁用函数辅助方法 */
function range(start, end) {
  const result = [];
  for (let i = start; i < end; i++) {
    result.push(i);
  }
  return result;
}

/**时间选择器确认回调 */
function onOk(value, dateString) {}

/**数组去重 */
function newArrFn(arr) {
  // .new Set方法，返回是一个类数组，需要结合 ...运算符，转成真实数组
  return [...new Set(arr)];
}

/**获取YYYY-MM-DD格式的当前日期，由文心一言生成 */
function getFormattedDate() {
  // 获取当前日期
  const now = new Date();

  // 获取年份（四位数）
  const year = now.getFullYear();

  // 获取月份（加1得到1-12的数值，然后用两位数表示）
  const month = String(now.getMonth() + 1).padStart(2, "0");

  // 获取日期（两位数表示）
  const day = String(now.getDate()).padStart(2, "0");

  // 拼接成字符串
  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
}

/**由于向数据库中传递时间的时候总会少八个小时，所以使用该方法进行时间矫正，由文心一言生成 */
function utcToCST(utcDate) {
  const offsetMilliseconds = 8 * 60 * 60 * 1000; // 8小时毫秒数
  const cstDate = new Date(utcDate.getTime() + offsetMilliseconds);
  return cstDate.toISOString().slice(0, -1) + "+08:00"; // 转换为ISO 8601格式并添加时区偏移量
}
</script>

<style scoped>
#maintenance {
  padding: 100px 0px;
  background-color: #f7f9fa;
}
.zeropadding {
  padding: 0px;
}
.card {
  box-sizing: border-box;
  border: none;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  margin: 20px 0px;
  overflow: visible;
  transition: all 0.4s;
  font-size: 14px;
  background-color: white;
}
.card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 1px rgba(0, 0, 0, 0.16);
}
.card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 1px rgba(0, 0, 0, 0.16);
}
.card-head {
  width: 100%;
  align-items: center;
  color: #333;
  display: flex;
  justify-content: space-between;
  padding: 12px 15px;
}
.card-content {
  width: 100%;
  min-height: 50px;
  padding: 15px;
  display: flex;
  flex-direction: column;
}
.info {
  display: flex;
  justify-content: space-between;
}
.noMore {
  overflow: hidden; /*超过部分不显示*/
  text-overflow: ellipsis; /*超过部分用点点表示*/
  white-space: nowrap; /*不换行*/
}
.confirmBtn {
  margin-left: 20px;
}
.footer {
  margin-top: 20px;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
}
</style>
